import { fetchFromOldApi } from '~/services/Http';

import { Contracts } from '../useScheduleChanges';

export const getContracts = async (
  profileId: number,
): Promise<{
  contracts: Contracts[];
  profile: { firstName: string; lastName: string };
}> => {
  return await fetchFromOldApi(`/json/persons/${profileId}/contracts`).then(
    (r) => r.json(),
  );
};

export const updateContracts = async (
  contractUid: string,
  profileId: number,
) => {
  await fetchFromOldApi(`/json/employee/${profileId}/defaultContract`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ contractUid }),
  });
};
